import React from "react";
import style from "./style.module.css";
import { Link } from "react-router-dom";
import Donate from "../../components/donate/Donate";
import { loadHome, addHomeArticle, selectGallery} from "./homeSlice";
import { useSelector, useDispatch} from "react-redux";

const Home = () => {

  const homeSliceState = useSelector(selectGallery);
  const homeData = homeSliceState.home;
  const dispatch = useDispatch();

  return (
    <div>
      {/* Banner section starts...*/}
      <section>
        <div className="banner">
          <div className="bannerContent">
            <h1 className="homePage-banner-title-A">A Non-Profitable Organization</h1>
            <h1 className="homePage-banner-title-A">To Support</h1>
            <h1 className="homePage-banner-title-B">Kathmandu Institute of Child Health</h1>
          </div>
        </div>
      </section>
      {/* Banner section ends...*/}

      <section>
        <div className="backgroundBuilding">
        <div className = "jumbotron">
          <h3 >We Are K-Pals UK</h3>
          <br/>
          <p className="fs-custom" style={{color:"darkblue",fontWeight:"bold"}}>We support Kathmandu Institute of Child Health (KIOCH) to provide affordable and accessible child health care in Nepal. 
            <br/>
            <a href="https://kioch.org.np" target="_blank" rel="noreferrer" style={{color:"blueviolet"}}> Learn More</a>
          </p>
          <hr />
          <br />
          <h4 >CHARITABLE OBJECTIVES</h4>
          <br />
          <p className="fs-custom" style={{color:"darkblue",fontWeight:"bold"}}>The main objectives of KPALS UK are to relieve sickness and promote the health of sick children in Nepal by providing or assisting in the provision of equipment, facilities, and training that complement the services provided by doctors.</p>
          <br/>
          <div className="donate-button">
            <a href="https://justgiving.com/kpals" target="_blank" rel="noreferrer" className="btn btn-primary btn-lg" role="button" aria-pressed="true" ><p style={{color:"white", fontWeight:"bold"}}>Donate Now</p></a>
          </div>
          
        </div>

        </div>
      </section>

      <section>
        <div className="whatWeDo">
          <h1 style={{color:"white",fontWeight:"bold"}}>What We Do</h1>
          <br />
          <p className="fs-responsive fs-custom" style = {{color:"white", textAlign:"justify"}}>KIOCH was introduced to the UK on July 4, 2023, at the Speakers’ State Room in Parliament House. K-PALS UK is a newly established charity in the UK dedicated to supporting the Kathmandu Institute of Child Health (KIOCH). Founded in 2017, <span><a href="https://kioch.org.np/" target="_blank" rel="noreferrer">KIOCH</a></span> is a non-profit organization committed to providing affordable and accessible child healthcare in Nepal.</p>

        </div>
      </section>

        <section>
        <div className="aboutKIOCH">
          <h1 style={{color:"darkblue",fontWeight:"bold"}}>More About KIOCH - Nepal</h1>
          <br/>
          <p className="fs-responsive fs-custom">KIOCH [Kathmandu Institute of Child Health] is a not-for-profit organization established in 2017. It aims to deliver integrated multispecialty high-quality child healthcare that is affordable, accessible, and available to all, thus advancing Quality of Life of Children in Nepal. KIOCH focuses on providing solutions to ever rising healthcare needs and consistent poor health outcomes for millions of children in Nepal. It believes on timely adaptation of scientific medical advances, technologies and valued people-centered care that are of international standards.</p>
          <br/>
          <br />
          <br />

          <div class="ratio ratio-16x9">
            <iframe src="https://www.youtube.com/embed/ejFDsungSpY" frameborder="0" allowfullscreen title="KIOCH Introduction Video"></iframe>
            {/* <iframe src="https://www.youtube.com/embed/gijMm5COtRI" frameborder="0" allowfullscreen></iframe> */}
          </div>

          {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/gijMm5COtRI" frameborder="0" allowfullscreen>
          </iframe> */}

        </div>
      </section>
      <section id='donateSection'>
        <Donate />
      </section>
      <section>
        <div className="aboutEvent">
          <h1 style={{color:"darkblue",fontWeight:"bold"}}>Join us on charity event - April 18, 2026</h1>
          <br/>
          <p className="fs-responsive fs-custom">Join us on 18th April 2026 for the Kathmandu Institute of Child Health- PALS UK Charity Event to support child health care in Nepal. <a href="https://www.eventbrite.com/e/kathmandu-institute-of-child-health-pals-uk-charity-event-tickets-1979667282132?utm_experiment=test_share_listing&aff=ebdsshios&sg=ce3fe984a1ae5e633e018733d497cbd5743a5cbf3d086a5ae461484bbbbac6f0eb528bf21a6723cc69563adee424caba7fc3ceb6abc1f9f87e437a8f7e28f6cfa70c4627a39c832f71f0e653" target="_blank" rel="noreferrer" style={{color:"darkblue", textDecoration:"underline",fontWeight:"bold"}}>Events Link</a></p>
          <a href="https://www.eventbrite.com/e/kathmandu-institute-of-child-health-pals-uk-charity-event-tickets-1979667282132?utm_experiment=test_share_listing&aff=ebdsshios&sg=ce3fe984a1ae5e633e018733d497cbd5743a5cbf3d086a5ae461484bbbbac6f0eb528bf21a6723cc69563adee424caba7fc3ceb6abc1f9f87e437a8f7e28f6cfa70c4627a39c832f71f0e653" target="_blank" rel="noreferrer"> <img src='../img/charity-events/charityEvents.jpg' alt='Charity Events' className='aboutEventImage'/> </a>
          
          {/* <img src='../img/charity-events/charityEvents.jpg' alt='Charity Events Image' className='aboutEventImage'/> */}
        </div>
      </section>

      <section>
        <div className="onlineInteractiveSession">         

          {/* <a href="https://www.youtube.com/watch?v=gHUkfKQ1SLg" target="_blank" rel="noreferrer"> <img src='../img/charity-events/online_interactive_session.jpeg' alt='Online Interactive Session' className='onlineInteractiveSessionImage'/>  </a>          */}
          
          <img src='../img/charity-events/online_interactive_session.jpeg' alt='Online Interactive Session' className='onlineInteractiveSessionImage'/> 
        </div>
      </section> 

      <section>
        <div className="recordedVideo" >
          <h1 style={{color:"darkblue",fontWeight:"bold"}}>Recorded Interactive Session on Paediatric Neurology with Dr. Dipak Ram</h1>
          <br/>
          <div class="ratio ratio-16x9">
            <iframe src="https://www.youtube.com/embed/gHUkfKQ1SLg" frameborder="0" allowfullscreen title="Interactive Session"></iframe>
            
          </div>      

        </div>
      </section>

      <section>
        <div className="recordedVideo" style={{backgroundColor:"white"}}>
          <h1 style={{color:"darkblue",fontWeight:"bold"}}>Recorded Interactive Session on Evidence Based Medicine with Mr Prajwal Ghimire</h1>
          <br/>
          <div class="ratio ratio-16x9">
            <iframe src="https://www.youtube.com/embed/hRUjSBHZS70" frameborder="0" allowfullscreen title="Interactive Session"></iframe>
            
        </div>      

        </div>
      </section>  

      <section>
        <div className="recordedVideo">
          <h1 style={{color:"darkblue",fontWeight:"bold"}}>Neonatal Resuscitation Updates by Dr Bernd Reichert - Moderator: Dr S Janakiraman</h1>
          <br/>
          <div class="ratio ratio-16x9">
            <iframe src="https://www.youtube.com/embed/JC0Iq9VaRzA" frameborder="0" allowfullscreen title="Neonatal Resuscitation Updates"></iframe>
            
        </div>      

        </div>
      </section> 

    </div>
  );
};

export default Home;
